import convertHexToRGB from '../contentFramePortalGateInternalMethods/utils/convertHexToRGB';

export default function getRgbaFromColor(color?: string): [number, number, number, number] | undefined {
  if (!color) {
    return;
  }

  if (color.startsWith('#')) {
    const rgb = convertHexToRGB(color);
    return [rgb[0], rgb[1], rgb[2], 1];
  }

  if (color.startsWith('rgb')) {
    const matches = color.match(/rgba?\((\d+),\s?(\d+),\s?(\d+)(?:,\s?([\d.]+))?\)/i);

    if (matches) {
      const red = parseInt(matches[1], 10);
      const green = parseInt(matches[2], 10);
      const blue = parseInt(matches[3], 10);
      const alpha = matches[4] !== undefined ? parseFloat(matches[4]) : 1;
      return [red, green, blue, alpha];
    }
  }
}
